// src/contexts/TitleContext/TitleContext.tsx

import React, { createContext, useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface TitleContextProps {
    title: string;
    setTitle: (newTitle: string) => void;
    resetTitle: () => void;
}

const DEFAULT_TITLE = "Turnieje Darta";

const TitleContext = createContext<TitleContextProps>({
    title: DEFAULT_TITLE,
    setTitle: () => {},
    resetTitle: () => {},
});

export const TitleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { t, i18n } = useTranslation();

    const [title, setTitle] = useState<string>(DEFAULT_TITLE);

    // Aktualizacja domyślnego tytułu po zmianie języka
    useEffect(() => {
        resetTitle();
    }, [i18n.language]);

    // Update document title when title state changes
    useEffect(() => {
        document.title = title;
    }, [title]);

    const resetTitle = () => setTitle(t("general.appName", DEFAULT_TITLE));

    return <TitleContext.Provider value={{ title, setTitle, resetTitle }}>{children}</TitleContext.Provider>;
};

// Custom hook to use the title context
export const useTitle = () => {
    const context = useContext(TitleContext);
    if (!context) {
        throw new Error("useTitle must be used within a TitleProvider");
    }
    return context;
};
